module.exports = "pegasus_template/assets/theme5/twitter-icon.png";